import $ from 'jquery';
import Mustache from 'mustache';

window.addEventListener('load', function() {

  var myMap = document.getElementById('map');
  var form = document.querySelector('.gform_body');
  if(!myMap && !form) return;

  var search_input;

  if(myMap){
    var isArchiveMap = myMap.classList.contains('js-archive_map') ? true : false;
    var isContactMap = myMap.classList.contains('js-contact_map') ? true : false;
    var mapGoogle;
    var currentDealers = [];
    var currentMarkersById = [];
    var currentMarkers = [];
    var currentInfowindows = {};
    var defaultZoom = isArchiveMap ? 6 : 11;
    var defaultPositionLat = 46.585398;
    var defaultPositionLng = 3.320208;
    var currentPositionLat = isArchiveMap ? defaultPositionLat : myMap.dataset.lat;
    var currentPositionLng = isArchiveMap ? defaultPositionLng : myMap.dataset.lng;
    if(isArchiveMap){
      search_input = document.getElementById('js-dealers_search'); // Autocomplete
      var searchedPlace;
      var is_search_value = typeof search_input.value !== 'undefined';
      var searchedPlaceLabel;
      var placeDepartement;
      var searchedPlaceType;
      var searchedPlaceData  = [];
      if(is_search_value) {
        searchedPlaceLabel = search_input.value;
        placeDepartement   = search_input.dataset.depname;
        var depCode = search_input.value.substr(0,2);
        searchedPlaceType  = depCode == '59' ? 'locality' : 'administrative_area_level_2';
        searchedPlaceData['postal_code'] = search_input.value;
      }
      var dealers_list_item_template;
      var dealer_infowindow_template;
      var dataToRender = {};
      var dataRendered = '';
  
    } else if(isContactMap){
      defaultPositionLat = myMap.dataset.lat;
      defaultPositionLng = myMap.dataset.lng;
    } else{
      if (document.querySelector('.post-type-concessionnaire')) {
        let dealer_id = document.querySelector('.post-type-concessionnaire').id;
      } else {
        let dealer_id = null;
      }
    }
  }
  if(form){
    search_input = document.querySelector('.js-input-city input'); // Autocomplete input
  }

  initMap();

  function initMap() {

    if(myMap){
      // Load Map
      mapGoogle = new google.maps.Map(myMap, {
        zoom: defaultZoom,
        minZoom: 4,
        center: new google.maps.LatLng(currentPositionLat, currentPositionLng),
        draggable: isArchiveMap,
        scrollwheel: isArchiveMap,
        zoomControl: false,
        streetViewControl: false,
        mapTypeControl: false,
        fullscreenControl: false,
        mapTypeId: 'roadmap', // roadmap, satellite, terrain, hybrid
        // gestureHandling: 'greedy'
      });

      // Create & apply Map Style
      var styledMapType = new google.maps.StyledMapType(
        [
          {
            "elementType": "geometry",
            "stylers": [
              {
                "color": "#f5f5f5"
              }
            ]
          },
          {
            "elementType": "labels.icon",
            "stylers": [
              {
                "visibility": "off"
              }
            ]
          },
          {
            "elementType": "labels.text.fill",
            "stylers": [
              {
                "color": "#616161"
              }
            ]
          },
          {
            "elementType": "labels.text.stroke",
            "stylers": [
              {
                "color": "#f5f5f5"
              }
            ]
          },
          {
            "featureType": "administrative.land_parcel",
            "elementType": "labels.text.fill",
            "stylers": [
              {
                "color": "#bdbdbd"
              }
            ]
          },
          {
            "featureType": "poi",
            "elementType": "geometry",
            "stylers": [
              {
                "color": "#eeeeee"
              }
            ]
          },
          {
            "featureType": "poi",
            "elementType": "labels.text.fill",
            "stylers": [
              {
                "color": "#757575"
              }
            ]
          },
          {
            "featureType": "poi.park",
            "elementType": "geometry",
            "stylers": [
              {
                "color": "#e5e5e5"
              }
            ]
          },
          {
            "featureType": "poi.park",
            "elementType": "labels.text.fill",
            "stylers": [
              {
                "color": "#9e9e9e"
              }
            ]
          },
          {
            "featureType": "road",
            "elementType": "geometry",
            "stylers": [
              {
                "color": "#ffffff"
              }
            ]
          },
          {
            "featureType": "road.arterial",
            "elementType": "labels.text.fill",
            "stylers": [
              {
                "color": "#757575"
              }
            ]
          },
          {
            "featureType": "road.highway",
            "elementType": "geometry",
            "stylers": [
              {
                "color": "#dadada"
              }
            ]
          },
          {
            "featureType": "road.highway",
            "elementType": "labels.text.fill",
            "stylers": [
              {
                "color": "#616161"
              }
            ]
          },
          {
            "featureType": "road.local",
            "elementType": "labels.text.fill",
            "stylers": [
              {
                "color": "#9e9e9e"
              }
            ]
          },
          {
            "featureType": "transit.line",
            "elementType": "geometry",
            "stylers": [
              {
                "color": "#e5e5e5"
              }
            ]
          },
          {
            "featureType": "transit.station",
            "elementType": "geometry",
            "stylers": [
              {
                "color": "#eeeeee"
              }
            ]
          },
          {
            "featureType": "water",
            "elementType": "geometry",
            "stylers": [
              {
                "color": "#c9c9c9"
              }
            ]
          },
          {
            "featureType": "water",
            "elementType": "labels.text.fill",
            "stylers": [
              {
                "color": "#9e9e9e"
              }
            ]
          }
        ]
      );
      mapGoogle.mapTypes.set('styled_map', styledMapType);
      mapGoogle.setMapTypeId('styled_map');
    }

    if(isArchiveMap || form){

      // On Autocomplete enter, auto select first choice
      (function pacSelectFirst(input){
        var _addEventListener = (input.addEventListener) ? input.addEventListener : input.attachEvent;

        if (input.addEventListener)
          input.addEventListener = addEventListenerWrapper;
        else if (input.attachEvent)
          input.attachEvent = addEventListenerWrapper;

        function addEventListenerWrapper(type, listener) {

          if (type == "keydown") {
            var orig_listener = listener;
            listener = function (event) {
              var suggestion_selected = $(".pac-item-selected").length > 0;
              if (event.which == 13 && !suggestion_selected) {
                event.preventDefault();
                var simulated_downarrow = $.Event("keydown", {keyCode:40, which:40})
                orig_listener.apply(input, [simulated_downarrow]);
              }
              orig_listener.apply(input, [event]);
            };
          }

          // add the modified listener
          _addEventListener.apply(input, [type, listener]);
        }
      })(search_input);
      // Init Autocomplete field - allowing only City searches
      var autocomplete = new google.maps.places.Autocomplete(search_input, {
        types: ['(regions)'],
        componentRestrictions: {country: "fr"}
      });
      // Bind the map's bounds (viewport) property to the autocomplete object,
      // so that the autocomplete requests use the current map bounds for the
      // bounds option in the request.
      if(isArchiveMap){
        autocomplete.bindTo('bounds', mapGoogle);
      }
      // Set the data fields to return when the user selects a place.
      autocomplete.setFields(['place_id', 'address_components', 'geometry', 'name']);
      // Events when User enter a place
      autocomplete.addListener('place_changed', function() {
        searchedPlace = autocomplete.getPlace();

        // Get Address Type - locality / country
        /**
         * CP          postal_code                 -> administrative_area_level_2                
         * CP59        postal_code                 -> postal_code                
         * Ville       locality                    -> administrative_area_level_2                   
         * Ville59     locality                    -> postal_code                   
         * Département administrative_area_level_2 -> administrative_area_level_2
         * Région      administrative_area_level_1 -> administrative_area_level_1 > admin_level_2
         * Pays        country                     -> country > admin_level_1 > admin_level_2                  
         */
        searchedPlaceType = null;
        searchedPlaceData = [];
        if (searchedPlace['address_components'].length){
          for (let i = 0; i < searchedPlace['address_components'].length; i++) {
            var address_component = searchedPlace['address_components'][i];
            for (let j = 0; j < address_component['types'].length; j++) {
              var address_component_type = address_component['types'][j];
              searchedPlaceData[address_component_type] = address_component['short_name'];
            }
          }
        }

        // Set searchedPlaceType from country to locality - Exception with Department 59
        if(searchedPlaceData['country'])
          searchedPlaceType = 'country';
        if(searchedPlaceData['administrative_area_level_1'])
          searchedPlaceType = 'administrative_area_level_1';
        if(searchedPlaceData['administrative_area_level_2'])
          searchedPlaceType = 'administrative_area_level_2';
        if(searchedPlaceData['postal_code'] || searchedPlaceData['locality']){
          if(searchedPlaceData['administrative_area_level_2'] == 'Nord')
            searchedPlaceType = 'locality';
        }

        // Set current search Position
        currentPositionLat = searchedPlace.geometry.location.lat();
        currentPositionLng = searchedPlace.geometry.location.lng();

        loadDealers();

      });
    }

    if(myMap)
      loadDealers();
  }

  /**
   * Load Dealers on List & Map & Move Map according to results
   */
  function loadDealers(){

    // Get input value on Page load, or get searched Place data
    if(isArchiveMap && is_search_value){
      is_search_value = false;
    } else{
      searchedPlaceLabel = searchedPlace 
        ? ((searchedPlaceType == 'locality') ? searchedPlaceData['locality'] : searchedPlace['name']) : '';
      placeDepartement = searchedPlace && (searchedPlaceData['administrative_area_level_2'] || searchedPlaceData['administrative_area_level_1']) 
        ? (searchedPlaceData['administrative_area_level_2'] ? searchedPlaceData['administrative_area_level_2']   : searchedPlaceData['administrative_area_level_1']) 
        : '';
    }

    // Google autocomplete Department translation
    if(placeDepartement === 'Brittany' || placeDepartement === 'Bretagne')
      placeDepartement = 'Finistère';
      
    if(isArchiveMap){
      $.ajax({
        type: 'GET',
        url: "/wp-json/decopierre/dealers",
        data: {
          lat: currentPositionLat,
          lng: currentPositionLng,
          isArchiveMap: isArchiveMap,
          place : searchedPlaceLabel,
          placeDepartement : placeDepartement,
          placeType: searchedPlaceType ? searchedPlaceType : null,
          placePostalCode: searchedPlaceData && searchedPlaceData['postal_code'] ? searchedPlaceData['postal_code'] : ''
        },
        success: function(data) {

          currentDealers = data.dealers;

          addDealersOnMap();
          addDealersInList(data);
        }
      });
    } else if(isContactMap){
      currentDealers = [
        {
          "lat" : currentPositionLat,
          "lng" : currentPositionLng
        }
      ];
      addDealersOnMap();
    } else{
      if (typeof dealer_id !== 'undefined') {
        $.ajax({
          type: 'GET',
          url: "/wp-json/decopierre/dealer",
          data: {
            dealer_id: dealer_id ? dealer_id : null
          },
          success: function(data) {
            currentDealers = data.dealers;
            addDealersOnMap();
          }
        });
      }
    }

  }

  /**
   * Add Dealers on Map & Auto Center Map
   */
  function addDealersOnMap() {

    // Clear Map Markers & Infowindows
    if(isArchiveMap){
      $.each(currentMarkersById, function (key, marker) {
        if (marker)
          marker.setMap(null);
      });
      currentMarkersById = [];
      currentInfowindows = [];
      currentMarkers     = [];
    }

    // Create all Dealers Markers & InfoWindows
    if(isArchiveMap){
      dealer_infowindow_template = $('#dealer_infowindow').html();
      Mustache.parse(dealer_infowindow_template);
      dataToRender = {};
      var lat_min = 999999;
      var lat_max = -999999;
      var lng_min = 999999;
      var lng_max = -999999;
    }
    $.each(currentDealers, function (key, dealer){

      var latitude = parseFloat(dealer.lat);
      var longitude = parseFloat(dealer.lng);
      var myLatLng = new google.maps.LatLng(latitude, longitude);
      if(isArchiveMap){
        if (latitude  < lat_min) lat_min = latitude;
        if (latitude  > lat_max) lat_max = latitude;
        if (longitude < lng_min) lng_min = longitude;
        if (longitude > lng_max) lng_max = longitude;
      }

      // Create marker
      var marker = new google.maps.Marker({
        id: dealer.ID,
        map: mapGoogle,
        position: myLatLng,
        icon: {
          path: "M0,-40c-7.312,0 -13.33,6.012 -13.338,13.324c0,12.008 13.338,26.676 13.338,26.676c0,0 13.338,-14.668 13.338,-26.676c-0.008,-7.312 -6.026,-13.324 -13.338,-13.324Zm0,18.67c0,0 0,0 0,0c-2.925,0 -5.332,-2.407 -5.332,-5.332c0,-0.005 0,-0.009 0,-0.014c0,-2.925 2.407,-5.332 5.332,-5.332c2.925,0 5.332,2.407 5.332,5.332c0,0.005 0,0.009 0,0.014c0,2.925 -2.407,5.332 -5.332,5.332c0,0 0,0 0,0Z",
          fillColor: "#d9953b",
          fillOpacity: 1,
          strokeWeight: 0,
        },
      });

      currentMarkersById[dealer['ID']] = marker;
      currentMarkers.push(marker);

      if(isArchiveMap){
        // Store Data & Create Marker InfoWindow
        dataToRender.id = dealer.ID;
        dataToRender.title = dealer.post_title;
        dataToRender.permalink = dealer.permalink;
        dataToRender.rue = dealer.rue;
        dataToRender.code_postal = dealer.code_postal;
        dataToRender.ville = dealer.ville;
        dataToRender.pays = dealer.pays;
        var tel_f = dealer.telephone_fixe;
        var tel_p = dealer.telephone_portable;
        dataToRender.telephone = tel_f && tel_p ? tel_f+' / '+tel_p : (tel_f ? tel_f : (tel_p ? tel_p : null));
        dataToRender.email = dealer.mail;
        dataToRender.website = dealer.website;
        dataToRender.direction = "https://www.google.com/maps/dir/?api=1&destination=" + encodeURIComponent(dealer.post_title+" "+dataToRender.rue+" "+dataToRender.code_postal+" "+dataToRender.ville+" "+dataToRender.pays);
        var infowindow = new google.maps.InfoWindow({
          content: Mustache.render(dealer_infowindow_template, dataToRender)
        });
        currentInfowindows[dealer['ID']] = infowindow;

        // Open Infowindow when Click on Marker
        google.maps.event.addListener(marker, 'click', function () {
          google.maps.event.trigger(mapGoogle, 'click');
          infowindow.open(mapGoogle, marker);
          $('.dealer--is-selected').removeClass('dealer--is-selected');
          $('.js-dealer#'+dealer['ID']).addClass('dealer--is-selected');
        });
        // Close Infowindow when Click on Map
        google.maps.event.addListener(mapGoogle, 'click', function () {
          infowindow.close();
          $('.dealer--is-selected').removeClass('dealer--is-selected');
        });
      }

    });

    // Set Map fitBounds / center & zoom
    if(isArchiveMap && searchedPlace){
      if(!currentMarkers.length){
        mapGoogle.panTo(new google.maps.LatLng(defaultPositionLat, defaultPositionLng));
        smoothZoom(mapGoogle, 5, mapGoogle.getZoom());
      } else if(currentMarkers.length == 1){
        // Prevent too close zoom if only one marker
        var lat_center = (parseFloat(lat_max) + parseFloat(lat_min)) / 2.0;
        var lng_center = (parseFloat(lng_max) + parseFloat(lng_min)) / 2.0;
        mapGoogle.panTo(new google.maps.LatLng(lat_center, lng_center));
        smoothZoom(mapGoogle, 11, mapGoogle.getZoom());
      }
      else{
        mapGoogle.fitBounds(new google.maps.LatLngBounds(
          new google.maps.LatLng(lat_min, lng_min), // bottom left
          new google.maps.LatLng(lat_max, lng_max) // top right
        ));
      }
    }

  }

  /**
   * Add Dealers in List // To Do with Mustache
   */
  function addDealersInList(data){
    $(".dealers__list__content").empty();

    // Get Dealers list item Template
    dealers_list_item_template = $('#dealers_list_item').html();
    Mustache.parse(dealers_list_item_template);
    dataToRender = {};
    dataRendered = '';

    // Get Dealers Data and Render on Template
    $.each(data.dealers, function (key, dealer) {
      dataToRender.id = dealer.ID;
      dataToRender.permalink = dealer.permalink;
      dataToRender.title = dealer.post_title;
      dataToRender.street = dealer.rue;
      dataToRender.postal = dealer.code_postal;
      dataToRender.city = dealer.ville;
      dataToRender.departments = dealer.departments;
      dataToRender.direction = "http://maps.google.com/maps?q=" + encodeURIComponent(dealer.post_title +" "+dealer.address);
      var tel_f = dealer.telephone_fixe;
      var tel_p = dealer.telephone_portable;
      dataToRender.telephone = tel_f && tel_p ? tel_f+' / '+tel_p : (tel_f ? tel_f : (tel_p ? tel_p : null));
      dataRendered += Mustache.render(dealers_list_item_template, dataToRender);

    });
    if(dataRendered)
      $('.dealers__list__content').html(dataRendered);

    // On click on list item, open related infowindow
    $(".dealers__list__content .js-locate_dealer").click(function() {
      var current_dealer = $(this).closest('.js-dealer');
      var current_dealer_id = current_dealer.attr('id');
      $.each(currentInfowindows, function (key,value) {
        if (currentInfowindows[key])
          currentInfowindows[key].close();
      });
      currentInfowindows[current_dealer_id].open(mapGoogle, currentMarkersById[current_dealer_id]);

      $('.dealer--is-selected').removeClass('dealer--is-selected');
      current_dealer.addClass('dealer--is-selected');

      $.each(currentMarkers, function (key,value) {
        if (value.id == current_dealer_id) {
          mapGoogle.panTo(value.position);
        }
      });

      smoothZoom(mapGoogle, 14, mapGoogle.getZoom());
    });

  }

  /**
   * Smooth zoom
   */
  function smoothZoom (map, level, cnt) {

    if(cnt == level)
      return;

    var direction = cnt < level ? cnt + 1 : cnt - 1;
    var z = google.maps.event.addListener(map, 'zoom_changed', function(event){
      google.maps.event.removeListener(z);
      smoothZoom(map, level, direction);
    });
    setTimeout(function(){map.setZoom(cnt)}, 80);

  }

});
